import { render, staticRenderFns } from "./mobile-checkbox-group.vue?vue&type=template&id=bbe85192&scoped=true&"
import script from "./mobile-checkbox-group.vue?vue&type=script&lang=ts&"
export * from "./mobile-checkbox-group.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-checkbox-group.vue?vue&type=style&index=0&id=bbe85192&prod&lang=less&scoped=true&"
import style1 from "./mobile-checkbox-group.vue?vue&type=style&index=1&id=bbe85192&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe85192",
  null
  
)

export default component.exports